import { RegaliaUxConstants } from '../constants';
import { getSmartHref } from '../util/smartHref';

export const RegaliaUxHelpContactInfo = ({ settingsList, consumerType, className }) => {
    const { PLEASE_CONTACT, YOUR_SCHOOL, FOR_HELP } = RegaliaUxConstants;
    const studentContactInfo = settingsList?.find(
        customerSettings => customerSettings.verificationType === consumerType
    )?.contactInfo;

    const contactHref = getSmartHref(studentContactInfo);

    return (
        <p className={`d-flex flex-wrap ${className}`}>
            <span className={contactHref ? 'mr-2' : 'mr-1'}>{PLEASE_CONTACT}</span>
            {contactHref
                ? <a className='mr-2 text-wrap' href={contactHref}>{studentContactInfo}</a>
                : <span className='mr-1'>{YOUR_SCHOOL}</span>
            }
            <span>{FOR_HELP}</span>
        </p>
    )
}